import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  #displayStickyAddToCart() {
    // La barre surgissait dès que le formulaire quittait l'écran, soit après un
    // seul défilement : le bouton d'origine venait à peine de disparaître qu'un
    // second apparaissait en bas. On attend un demi-écran de plus.
    let seuilAtteint = true;
    if (this.form) {
      const basDuFormulaire = this.form.getBoundingClientRect().bottom + window.scrollY;
      seuilAtteint = window.scrollY > basDuFormulaire + window.innerHeight * 0.5;
    }

    if (!seuilAtteint || isElementInViewport(this.form) || isElementInViewport(this.footer)) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
